import { z } from 'zod';

import { InstagramCreatorInterest } from '@frontend/gql/social/graphql';

export const INSTAGRAM_CREATOR_INTEREST = {
  ANIMALS_AND_PETS: 'ANIMALS_AND_PETS',
  BOOKS_AND_LITERATURE: 'BOOKS_AND_LITERATURE',
  BUSINESS_FINANCE_AND_ECONOMICS: 'BUSINESS_FINANCE_AND_ECONOMICS',
  EDUCATION_AND_LEARNING: 'EDUCATION_AND_LEARNING',
  BEAUTY: 'BEAUTY',
  FASHION: 'FASHION',
  FITNESS_AND_WORKOUTS: 'FITNESS_AND_WORKOUTS',
  FOOD_AND_DRINK: 'FOOD_AND_DRINK',
  GAMES_PUZZLES_AND_PLAY: 'GAMES_PUZZLES_AND_PLAY',
  HISTORY_AND_PHILOSOPHY: 'HISTORY_AND_PHILOSOPHY',
  HOLIDAYS_AND_CELEBRATIONS: 'HOLIDAYS_AND_CELEBRATIONS',
  HOME_AND_GARDEN: 'HOME_AND_GARDEN',
  MUSIC_AND_AUDIO: 'MUSIC_AND_AUDIO',
  PERFORMING_ARTS: 'PERFORMING_ARTS',
  SCIENCE_AND_TECH: 'SCIENCE_AND_TECH',
  SPORTS: 'SPORTS',
  TV_AND_MOVIES: 'TV_AND_MOVIES',
  TRAVEL_AND_LEISURE_ACTIVITIES: 'TRAVEL_AND_LEISURE_ACTIVITIES',
  VEHICLES_AND_TRANSPORTATION: 'VEHICLES_AND_TRANSPORTATION',
  VISUAL_ARTS_ARCHITECTURE_AND_CRAFTS: 'VISUAL_ARTS_ARCHITECTURE_AND_CRAFTS',
} as const satisfies Record<string, InstagramCreatorInterest>;

export const InstagramCreatorInterestSchema = z.nativeEnum(INSTAGRAM_CREATOR_INTEREST);
